module.exports = __webpack_public_path__ + "img/Menu-12.6eb1aea7.webp";